import React from 'react';
import './_loader.scss';

function Loader() {
  return (
    <main className="main">
      <div className="wrapper main__wrapper">
        <div className="main__content">
          <div className="loader">
            <div className="loading">
              <h2>react fetching</h2>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Loader;
